let ctx = null;
let master = null;
let enabled = false;
const listeners = new Set();

function noise(seconds, brown) {
  const len = Math.floor(ctx.sampleRate * seconds);
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const d = buf.getChannelData(0);
  let last = 0;
  for (let i = 0; i < len; i++) {
    const w = Math.random() * 2 - 1;
    if (brown) {
      last = (last + 0.02 * w) / 1.02;
      d[i] = last * 3.5;
    } else d[i] = w;
  }
  return buf;
}

function startBreeze() {
  const src = ctx.createBufferSource();
  src.buffer = noise(6, true);
  src.loop = true;
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 520;
  lp.Q.value = 0.8;
  const g = ctx.createGain();
  g.gain.value = 0.32;
  const lfo = ctx.createOscillator();
  lfo.frequency.value = 0.07;
  const lfoAmt = ctx.createGain();
  lfoAmt.gain.value = 320;
  lfo.connect(lfoAmt).connect(lp.frequency);
  const lfo2 = ctx.createOscillator();
  lfo2.frequency.value = 0.11;
  const lfo2Amt = ctx.createGain();
  lfo2Amt.gain.value = 0.14;
  lfo2.connect(lfo2Amt).connect(g.gain);
  src.connect(lp).connect(g).connect(master);
  src.start();
  lfo.start();
  lfo2.start();
}

export function fizz(strength = 1) {
  if (!enabled || !ctx) return;
  const dur = 0.5 + 0.5 * strength;
  const len = Math.floor(ctx.sampleRate * dur);
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) {
    const p = i / len;
    if (Math.random() < 0.05 * (1 - p)) d[i] = (Math.random() * 2 - 1) * (1 - p);
  }
  const src = ctx.createBufferSource();
  src.buffer = buf;
  const hp = ctx.createBiquadFilter();
  hp.type = "highpass";
  hp.frequency.value = 3200;
  const g = ctx.createGain();
  g.gain.value = 0.28 * strength;
  src.connect(hp).connect(g).connect(master);
  src.start();
}

export function setSound(on) {
  if (on && !ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = 0;
    master.connect(ctx.destination);
    startBreeze();
  }
  if (!ctx) return;
  enabled = on;
  if (on) ctx.resume();
  const now = ctx.currentTime;
  master.gain.cancelScheduledValues(now);
  master.gain.setTargetAtTime(on ? 0.7 : 0, now, 0.4);
  listeners.forEach((l) => l(on));
  if (on) setTimeout(() => fizz(1), 150);
}

export const isSoundOn = () => enabled;
export function onSound(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
